import React, { useState } from 'react';

import ContentCopyOutlinedIcon from '@mui/icons-material/ContentCopyOutlined';
import { Alert, Box, Button, TextField } from '@mui/material';

import type { Lens } from '~/types/leLens';

import { lensAiContext } from './lensShareContent';
import type { LensUrlState } from './lensUrlState';

interface Props {
  lens: Lens;
  url: string;
  view?: LensUrlState;
  disabled?: boolean;
}

export default function LensShareExport({ lens, url, view, disabled }: Props) {
  const [feedback, setFeedback] = useState<'copied' | 'failed' | null>(null);
  const content = lensAiContext(lens, url, view);

  return (
    <Box sx={{ mt: 3 }}>
      <Button
        disabled={disabled}
        startIcon={<ContentCopyOutlinedIcon />}
        onClick={async () => {
          try {
            await navigator.clipboard.writeText(content);
            setFeedback('copied');
          } catch {
            setFeedback('failed');
          }
        }}
      >
        AI Handover
      </Button>
      {feedback && (
        <Alert severity={feedback === 'copied' ? 'success' : 'error'} sx={{ mt: 1 }}>
          {feedback === 'copied'
            ? 'Copied. Paste into your AI tool.'
            : 'Copy failed. Select and copy the handover below.'}
        </Alert>
      )}
      {feedback === 'failed' && (
        <TextField
          label="AI Handover"
          value={content}
          multiline
          maxRows={10}
          fullWidth
          slotProps={{ input: { readOnly: true } }}
          sx={{ mt: 1 }}
        />
      )}
    </Box>
  );
}
